import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import StructurePageManager from "../../components/pageManager/StructurePageManager";

const NewsManagerPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <StructurePageManager />
                </div>
            </div>
        </div>
    );
};

export default NewsManagerPage;
